// ======================================================================
// File Name       : ContentDrillSkinCheck
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Modal, Button } from 'react-bootstrap';
import ContentDrillSkinDetail from './ContentDrillSkinDetail';
import { MODE, MODAL_SIZE } from '../../constants/index';

class ContentDrillSkinCheck extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: MODE.NEW_MODE,
      showCheck: false,
      skinSetInfo: {},
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.skinSetInfo) {
      const {
        mode,
        showCheck,
        skinSetInfo,
      } = nextProps;
      this.setState({
        mode,
        showCheck,
        skinSetInfo,
      });
    }
  }

  render() {
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
    return (
      <Modal
        className="modal-container"
        show={this.state.showCheck}
        onHide={this.props.onCancel}
        size={MODAL_SIZE.lg}
        style={style}
      >

        <Modal.Header onHide={this.props.onCancel} closeButton>
          <Modal.Title className="text-center">
            以下の内容で登録します
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <ContentDrillSkinDetail {...this.state} isCheck />
        </Modal.Body>
        <Modal.Footer>
          <Col sm={12} className="text-center">
            <Button
              variant="default"
              className="btn-96 margin-10"
              onClick={this.props.onCancel}
            >
              キャンセル
            </Button>
            <Button
              variant="primary"
              className="btn-96 margin-10"
              onClick={this.props.onOK.bind(this)}
            >
              OK
            </Button>
          </Col>

        </Modal.Footer>
      </Modal>
    );
  }
}

export default ContentDrillSkinCheck;
